import { presentLoanInformationForApiResolver } from "resolvers";
import { update } from "services/loanInformation";

const updateLoanInformationModel = async (accessToken, clientId, data) => {
  const requestData = presentLoanInformationForApiResolver(data);
  return await update(accessToken, clientId, requestData);
};

export default updateLoanInformationModel;
